import "./App.css";
import { useDispatch, useSelector } from "react-redux";
import { userActions } from "./redux/actions/user.actions";
import SignUp from "./pages/SignUpComponent/SignUp.Component";
import Login from "./pages/LoginPageComponent/LoginPage.Component.jsx";
import VerifyPage from "./pages/VerifyPageComponent/VerifyPage.Component.jsx";
import ForgetPassword from "./pages/ForgetPasswordComponent/ForgetPassword.Component";
import LandingPage from "./pages/LandingPagecomponent/LandingPage.Component";
import {
  Switch,
  Route,
  HashRouter as Router,
  useHistory,
  withRouter,
} from "react-router-dom";
import React, { useState, useEffect } from "react";
import PrintCompanyProfileComponent from "./pages/PrintCompanyProfileComponents/PrintCompanyProfile.Component";
import ResetPassword from "./pages/ResetPasswordComponent/ResetPassword.Component.jsx";
import ResetPasswordInstruction from "./pages/ResetPasswordInstructionComponent/ResetPasswordInstruction.Component.jsx";
import PasswordChangeSuccess from "./pages/PasswordChangeSuccessComponent/PasswordChangeSuccess.Component.jsx";
import SignUpSuccess from "./pages/SignUpSuccessComponent/SignUpSuccessComponent.jsx";
import ChangeOrderStatus from "./pages/ChangesAndOrderRequest/ChangeOrderStatusComponent/ChangeOrderStatus.component";
import Cookies from "universal-cookie";
import { isLocalhost } from "./util/helpers.js";
import { setUser } from "@sentry/react";

function App() {
  const history = useHistory();
  const dispatch = useDispatch();
  const [recentSearch, setRecentSearch] = useState([]);
  const [searchToken, setSearchToken] = useState("");
  const [searchUserName, setSearchUserName] = useState("");
  const param = history.location.search && history.location.search.split("=");
  const token = param && param[1] && param[1].split("&");
  const loggedUserInfo = useSelector((state) => state.loggedUserInfo);
  const userId =
    loggedUserInfo && loggedUserInfo.items && loggedUserInfo.items.IDPrimeUser;
  const clientId =
    loggedUserInfo &&
    loggedUserInfo.items &&
    loggedUserInfo.items.IDClientProfile;
  const [searchCompany, setSearchCompany] = useState([]);

  const cookies = new Cookies();

  const recentCompanyList = useSelector((state) => state.recentCompanyList);

  const isAppOnLocalhost = isLocalhost()
    ? ".localhost.com"
    : process.env.REACT_APP_DOMAIN;

  const cookieOptions = {
    domain: isAppOnLocalhost,
    path: "/",
  };

  // eslint-disable-next-line
  useEffect(() => {
    //  console.log(`In ${timer} seconds you will be automatically logged out`)
    setSearchToken(token && token[0]);
    setSearchUserName(param && param[2] && param[2]);
    if (searchToken) {
      localStorage.setItem("token", JSON.stringify(searchToken));
      cookies.set("token", JSON.stringify(searchToken), cookieOptions);
      localStorage.setItem("userName", searchUserName);
    }

    //localStorage.setItem("userName", userName);
  });
  useEffect(() => {
    dispatch(userActions.getLoggedUserInfo());
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    const email = cookies.get('userName');
    if (email) {
      setUser({
        email,
      });
    }
  }, [cookies]);

  useEffect(() => {
    window.onbeforeunload = confirmExit;
    function confirmExit() {
      return "show warning";
    }
  }, []);

  return (
    <Router history={history}>
      <Switch>
        <Route path="/signUp" component={SignUp} />
        <Route path="/login" component={Login} />
        <Route path="/verify/:email/:validationToken" component={VerifyPage} />
        <Route path="/forgetPassword" component={ForgetPassword} /> 
        <Route path="/ResetSuccess" component={ResetPasswordInstruction} />
        <Route path="/Account/ResetPassword" component={ResetPassword} />
        <Route
          path="/PasswordChangeSuccess"
          component={PasswordChangeSuccess}
        />
        <Route path="/">
          <LandingPage
            recentSearch={recentSearch}
            setRecentSearch={setRecentSearch}
            loggedUserInfo={loggedUserInfo}
            userId={userId}
            clientId={clientId}
            searchCompany={searchCompany}
            setSearchCompany={setSearchCompany}
            recentCompanyList={recentCompanyList}
          />
        </Route>
        <Route
          path="/PrintCompanyProfile"
          component={PrintCompanyProfileComponent}
        />
        <Route path="/SignUpSuccess" component={SignUpSuccess} />
        <Route path="/ChangeOrderStatus" component={ChangeOrderStatus} />
      </Switch>
    </Router>
  );
}

export default withRouter(App);
